import {Graphics, Sprite, Text} from 'pixi.js';
import {StaticData} from '../../../../data/StaticData';
import {TextFactory} from '../../../../factories/TextFactory';

export class PieMenuCenter extends Sprite
{
    private readonly circle: Graphics;
    private readonly hintText: Text;

    constructor(private radius: number = 50) {
        super();

        this.circle = new Graphics();
        this.circle.beginFill(StaticData.pieMenuColorNormal);
        this.circle.drawCircle(0, 0, radius);
        this.circle.endFill();
        this.addChild(this.circle);

        this.hintText = TextFactory.create('');
        this.addChild(this.hintText);
    }

    clear() {
        this.hintText.text = '';
    }

    /**
     * Отрисовка подсказки
     * @param hint - текст подсказки
     */
    setHintText(hint: string) {
        this.hintText.text = hint;
        this.hintText.anchor.set(.5, .5);
    }
}
